<template>
  <v-card flat class="pt-2">
    <v-layout v-if="jobNotes">
      <v-flex xs1 pt-0 class="text-xs-left">
        <span class="fake-label">Done</span>
      </v-flex>
      <v-flex xs10 pt-0 class="text-xs-left" style="padding-left:15px;" >
        <span class="fake-label">Task</span>
      </v-flex>
    </v-layout>
    <v-layout mb-3 align-end row fill-height v-for="(note, noteindex) in jobNotes"  :key="note.id">
      <v-flex xs1 pt-0 class="text-xs-left" >
        <v-checkbox
        :id="'noteDone-'+ listId + '-' + noteindex"
        v-model="note.done"
        input-value="Boolean"
        hide-details
        light
        color="primary"
        @change="updateJobNote(note, jobId)"
        ></v-checkbox>
      </v-flex>
      <v-flex xs10 pt-0 style="padding-left:15px;" >
        <v-text-field
        name="noteText"
        :id="'noteText-'+ listId + '-' + noteindex"
        v-model="note.noteText"
        required
        placeholder=" "
        hide-details
        ref="linefocus"
        @focus="$event.target.select()"
        @change="updateJobNote(note, jobId)"
        @keyup.enter="updateJobNote(note, jobId)"
        ></v-text-field>
      </v-flex>
      <v-flex xs1 pt-0 class="text-xs-right">
          <v-icon @click="deleteJobNote(note.id, jobId)" class="small-icon error--text">close</v-icon>
      </v-flex>
    </v-layout>
    <v-layout v-if="!jobNotes || Object.keys(jobNotes).length === 0">
      <v-flex style="padding: 15px 0 0;">
        <p class="body-small subtle">You can use tasks as a checklist for this job.</p>
      </v-flex>
    </v-layout>
    <v-layout pt-2 pb-0>
      <v-flex>
        <v-btn class="mt-2 text-none" small depressed @click="addJobNote()">
          + add task
        </v-btn>
      </v-flex>
    </v-layout>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Confirm from '@/components/Shared/Confirm'

export default {
  name: 'JobTasks',
  components: {
    Confirm
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      user: this.$store.getters.user,
      jobNotes: this.job.notes,
      jobId: this.job.id,
      listId: this.job.listId
    }
  },
  watch: {
    job (newValue) {
      // when the job updates update our component
      // when we add, delete update bring it back here
      this.jobNotes = this.job.notes
    }
  },
  methods: {
    addJobNote () {
      this.$store.commit('setLoading', true)
      const listId = this.listId
      const jobId = this.jobId
      const groupId = this.user.group
      // get key
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/notes').push().key
      // build object
      const note = {
        id: ref,
        noteText: '',
        done: false,
        creatorId: this.user.id
      }
      // update the current in-edit job in the store with the notes and new note
      this.$store.commit('setJobDetailModalJob', {
        ...this.job,
        'notes': {
          ...this.jobNotes,
          [ref]: note
        }
      })
      // set with key to FB
      firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/notes' + '/' + ref).set(note)
        .then((data) => {
          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
      // focus this note
      this.$nextTick(() => {
        this.$refs.linefocus[this.$refs.linefocus.length - 1].focus()
      })
    },
    async deleteJobNote (noteId, jobId) {
      // confirm we want to do this
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        this.$store.commit('setLoading', true)
        const group = this.user.group
        // remove the note from our local data
        this.$delete(this.jobNotes, noteId)
        // commit the jobnotes Object to the in-edit job
        this.$store.commit('setJobDetailModalJob', {
          ...this.job,
          'notes': {
            ...this.jobNotes
          }
        })
        // write the changes to firebase
        firebase.database().ref('lists/' + group + '/list' + this.listId + '/' + this.jobId + '/notes' + '/' + noteId).remove()
          .then((data) => {
            this.$store.commit('setLoading', false)
          })
          .catch((error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          })
      }
    },
    updateJobNote (note, jobId) {
      this.$store.commit('setLoading', true)
      const listId = this.listId
      const groupId = this.user.group
      // commit the jobnotes Object to the in-edit job
      this.$store.commit('setJobDetailModalJob', {
        ...this.job,
        'notes': {
          ...this.jobNotes
        }
      })
      // write the changes to firebase
      firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/notes' + '/' + note.id).set(note)
        .then((data) => {
          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
    }
  }
}
</script>

<style scoped>
.v-input--selection-controls{
  padding-top:3px;
  margin-top:0;
}
.line-delete{
  flex-shrink: 0;
  flex-basis:15px;
  margin-left:5px;
}
.small-icon{
  font-size:15px;
}
</style>
